












































































import Vue from "vue";
import SmallTable, { Action, Header } from "@/components/ui/SmallTable.vue";
import UploadDialog from "@/components/dialog/UplaodDialog.vue";
import LoadingScreen from "@/components/dialog/LoadingScreen.vue";

import ValidationService from "@/services/ValidationService";
import AlertService from "@/services/libs/AlertService";
import { Dokument, Element, Kategorie, Rolle, UploadDokument } from "@/types";
import { RequestError } from "@/services/AuthService";
import { Massnahme } from "@/types/Massnahme";
import { erklServiceInstance } from "@/services/ErklService";
import { alertError } from "@/services/ErrorAlert";
import { massnahmenServiceInstance } from "@/services/MassnahmenService";
import ContactTable from "@/components/ui/ContactTable.vue";
import { Ansprechpartner } from "@/types/Ansprechpartner";

export default Vue.extend({
  name: "DatenTab",
  components: {
    SmallTable,
    UploadDialog,
    LoadingScreen,
    ContactTable,
  },
  props: {
    /** maßnahme  */
    value: {
      type: Object as () => Massnahme,
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      isUploading: false,
      isDownloading: false,
      uploadProgress: undefined as undefined | number,
      downloadProgress: undefined as undefined | number,
      openUploadDialog: false,
      institutionen: [] as Element[],
      rollen: [] as Rolle[],
      categories: [] as Kategorie[],
      newDokument: {} as UploadDokument,
      newTermin: { datum: new Date().getTime() },
      documentActions: [
        {
          title: "Dokument Öffnen",
          type: "is-primary",
          icon: "download",
          public: true,
          f: (d: any): void => (this as any).openDokument(d),
        },
      ] as Action[],
      tableTermineHeader: [
        {
          field: "datum",
          label: "Datum",
          type: "date",
          sortable: true,
        },
        { field: "thema", label: "Thema", sortable: true },
      ] as Header[],
    };
  },
  computed: {
    tableDocumentsHeader(): Header[] {
      return [
        { field: "bezeichnung", label: "Bezeichnung", sortable: true },
        {
          field: "kategorie",
          label: "Kategorie",
          display: (item: any): String => item?.bez || "-",
          type: "select",
          placeholder: "auswählen",
          options: this.categories,
          sortable: true,
        },
        {
          field: "kurzbeschreibung",
          label: "Kurzbeschreibung",
          type: "textarea",
          maxlength: 2000,
          sortable: true,
        },
        {
          field: "filesize",
          type: "filesize",
          label: "Größe",
          readonly: true,
          sortable: true,
          numeric: true,
        },
        { field: "autor", label: "Autor", readonly: true, sortable: true },
        {
          field: "datum",
          label: "Datum",
          type: "date",
          readonly: true,
          sortable: true,
        },
      ] as Header[];
    },
  },
  mounted() {
    this.isLoading = true;
    Promise.all([
      erklServiceInstance
        .getKategorien()
        .then((data: Kategorie[]) => (this.categories = data)),

      erklServiceInstance
        .getRollen()
        .then((data: Rolle[]) => (this.rollen = data)),
    ])
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  methods: {
    resetAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.value.ansprechpartner.map((x) =>
        x.id === data.id
          ? {
              ...x,
              rollen: [],
              namen: [],
              telefon: "",
              email: "",
              bemerkung: "",
            }
          : x,
      );
      this.value.ansprechpartner = items;
    },

    removeAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.value.ansprechpartner.map((x) =>
        x.id === data.id
          ? { ...x, rollen: [], telefon: "", email: "", bemerkung: "" }
          : x,
      );
      this.value.ansprechpartner = items;
    },

    getAnsprechpartner: function (data: Ansprechpartner) {
      console.info("reset aaa " + data.checkId);
      const items = this.value.ansprechpartner.map((x) =>
        x.id === data.id ? data : x,
      );
      this.value.ansprechpartner = items;
    },
    validateAndSave() {
      let valid = true;
      for (let i = 0; i < this.value.ansprechpartner?.length; i++) {
        if (
          !ValidationService.validEmail(this.value.ansprechpartner[i].email)
        ) {
          valid = false;
          break;
        }
      }
      if (valid) this.$emit("save");
      else AlertService.error("Die Emailaddresse(n) sind nicht valide!");
    },
    onUpload(document: UploadDokument) {
      this.openUploadDialog = true;
      this.newDokument = document;
      // create documents array if not exist
      if (!this.value.dokumente) this.value.dokumente = [];
    },
    onUploadConfirm(document: UploadDokument) {
      if (!document.file) {
        AlertService.warning(
          "Upload ungültig!",
          "Es muss eine Datei ausgewählt werden.",
        );
        return;
      }
      this.isUploading = true;
      massnahmenServiceInstance
        .uploadDokument(
          this.value.id,
          document,
          (e: any) => (this.uploadProgress = (e.loaded / e.total) * 100),
        )
        .then((document: Dokument) => {
          // add new document to list
          this.value.dokumente.unshift(document);
          // clear newDokument object
          this.newDokument = {} as UploadDokument;
          AlertService.info("Dokument hochgeladen!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Hochladen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isUploading = false;
          this.uploadProgress = undefined;
        });
    },
    onUploadCancel() {
      // remove new document from list
      const index = this.value.dokumente.findIndex(
        (el: any) => el.id == (this.newDokument as any)?.id,
      );
      if (index != -1) this.value.dokumente.splice(index, 1);
      // clear newDokument object
      this.newDokument = {} as UploadDokument;
    },
    openDokument(dokument: Dokument) {
      this.isDownloading = true;
      massnahmenServiceInstance
        .openDokument(
          this.value.id,
          dokument,
          (e: any) => (this.downloadProgress = (e.loaded / e.total) * 100),
        )
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Öffnen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isDownloading = false;
          this.downloadProgress = undefined;
        });
    },
  },
});
